import React from 'react';
import CourseOverview from './CourseOverview';
import SubjectOverview from './SubjectOverview';
import GradingSystems from './GradingSystems';


export default class AdminView extends React.Component {

	constructor() {
		super();

        this.navName = "courseOverview";
		this.state = { key: 0 }
    }
    
    logout() {
        this.props.handleLogoutEvent();
    }

    getRenderBlock() {
        if (this.navName === "subjectsOverview") {
            return (
                <SubjectOverview key={ this.state.key } CheckAuthError={ this.props.CheckAuthError } LogoutOnCookieNotSet={ this.props.LogoutOnCookieNotSet } />
            );
        }
        else if (this.navName === "courseOverview") {
            return (
                <CourseOverview firstname={ this.props.firstname } lastname={ this.props.lastname } sex={ this.props.sex } key={ this.state.key } CheckAuthError={ this.props.CheckAuthError } LogoutOnCookieNotSet={ this.props.LogoutOnCookieNotSet } />
            );
        } else if (this.navName === "gradingSystemView") {
            return (
                <GradingSystems key={ this.state.key } CheckAuthError={ this.props.CheckAuthError } LogoutOnCookieNotSet={ this.props.LogoutOnCookieNotSet } />
            );
        }
    }
    render(){
		return (
            <div>
                <nav className="navbar navbar-default">
                    <div className="container">
                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                            <a style={{fontSize: "14px"}} className="navbar-brand" href="https://www.medizinische-assistenzberufe.at">
                                <span style={{marginRight: "10px"}}><img className="navbar-image-container" src="./img/logo.jpg" alt="ForMed"></img></span>
                                Startseite
                            </a>
                        </div>

                        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                            <ul className="nav navbar-nav navbar-right">
                                <li><a className={(this.navName === "courseOverview") ? "active-nav" : "not-active-nav" } onClick={ () => { this.navName = "courseOverview"; this.setState({ key: Math.random() }); } }>Kursübersicht</a></li>
                                <li><a className={(this.navName === "subjectsOverview") ? "active-nav" : "not-active-nav" } onClick={ () => { this.navName = "subjectsOverview"; this.setState({ key: Math.random() }); } }>Fächer</a></li>
                                <li><a className={(this.navName === "gradingSystemView") ? "active-nav" : "not-active-nav" } onClick={ () => { this.navName = "gradingSystemView"; this.setState({ key: Math.random() }); } }>Benotungssysteme</a></li>
                                <li><a className="not-active-nav" onClick={ () => this.logout() }>Logout</a></li>
                            </ul>
                        </div>
                    </div>
                </nav>
                <main>
                    { this.getRenderBlock() }
                </main>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/admin/AdminView.js